import { CartComponent } from './cart/cart.component';
import { CaseViewComponent } from './case-view/case-view.component';
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './shared/auth-guard';
import { BondsmanComponent } from './bondsman/bondsman.component';
import { BondsmanDetailComponent } from './bondsman/bondsman-detail.component';
import { CanActivateDisclaimerGuard } from './civil/can-activate-disclaimer-guard';
import { CivilComponent } from './civil/civil.component';
import { CivilPilotPatGuard } from './civil/civil-pilot-pat.guard';
import { JuvenileComponent } from './juvenile/juvenile.component';
import { LandingComponent } from './landing/landing.component';
import { LogoutComponent } from './login/logout.component';
import { PageNotFoundComponent } from './shared/page-not-found.component';
import { PublicAccessTerminalComponent } from './shared/public-access-terminal.component';
import { SequencerGuard } from './shared/sequencer.guard';

const appRoutes: Routes = [
  { path: '',
    component: LandingComponent,
    canActivate: [AuthGuard]
  },
  { path: 'public_access_terminal',
    component: PublicAccessTerminalComponent
  },
  { path: 'logout',
    component: LogoutComponent
  },
  { path: 'civil/:caseCategory', // TODO: 20180306 refactor out caseCategory
    component: CivilComponent,
    data: {
      guardSequence: [ 'AuthGuardClassName', 'CivilPilotPatGuard', 'CanActivateDisclaimerGuard' ]
    },
    canActivate: [
      SequencerGuard
    ]
  },
  { path: 'juvenile',
    component: JuvenileComponent,
    canActivate: [
      AuthGuard
    ]
  },
  { path: 'bondsman',
    component: BondsmanComponent
    // ,canActivate: [ AuthGuard ]
  },
  {
    path: 'details/:type/:county/:casenumber',
    component: CaseViewComponent,
    canActivate: [AuthGuard],
    outlet: 'view'
  },
  {
    path: 'bondsman/:licensenumber/:statelicenseid',
    component: BondsmanDetailComponent,
    // canActivate: [AuthGuard],
    outlet: 'view'
  },
  {
    path: 'cart',
    component: CartComponent,
    canActivate: [AuthGuard],
    outlet: 'view'
  },
  { path: '**', component: PageNotFoundComponent }
];

export const appRoutingProviders: any[] = [
  AuthGuard,
  SequencerGuard,
  {
    provide: 'AuthGuardClassName',
    useClass: AuthGuard
  },
  {
    provide: 'CanActivateDisclaimerGuard',
    useClass: CanActivateDisclaimerGuard
  },
  {
    provide: 'CivilPilotPatGuard',
    useClass: CivilPilotPatGuard
  }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, {useHash: false});



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/app.routing.ts